////////////////////////////////////////////////////////////////////
// This file contains configs that add analytics integrations     //
////////////////////////////////////////////////////////////////////

// Note: These come from the analytics asset nowadays by default.
//       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeAnalyticsConfig func)

// Optional
// Note that Google Analytics might need advanced opt-out option / cookie consent
// depending on jurisdiction (e.g. EU countries), since it relies on cookies.
export const googleAnalyticsId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

// Optional
// If you add this Plausible integration, you should first create an account in plausible.io
// This adds data-domains for Plausible script through environment variable: REACT_APP_PLAUSIBLE_DOMAINS
// https://plausible.io/docs/plausible-script#can-i-send-stats-to-multiple-dashboards-at-the-same-time
// You can add multiple domains separated by comma
// E.g. REACT_APP_PLAUSIBLE_DOMAINS=example1.com,example2.com
export const plausibleDomains = process.env.REACT_APP_PLAUSIBLE_DOMAINS;

// Optional
// Klaviyo onsite tracking pixel. The 6-character public company ID is found in
// Klaviyo > Account > Settings > API Keys. When set, the onsite snippet is loaded
// site-wide and exposes window.klaviyo for identifying users and tracking events.
export const klaviyoCompanyId = process.env.REACT_APP_KLAVIYO_COMPANY_ID;

// Optional
// Tapfiliate affiliate tracking. The public account id (e.g. "63752-7ef7cf") is
// found in Tapfiliate > Settings. When set, the tapfiliate.js click-tracking
// snippet is loaded site-wide; inbound ?ref= referral clicks are detected and the
// referral code is captured (see src/util/tapfiliate.js). Conversions are tracked
// server-side from the transaction poller, not via the client pixel.
export const tapfiliateAccountId = process.env.REACT_APP_TAPFILIATE_ACCOUNT_ID;
